import { render, staticRenderFns } from "./HomeRecommended.vue?vue&type=template&id=056e8e30"
import script from "./HomeRecommended.vue?vue&type=script&lang=js"
export * from "./HomeRecommended.vue?vue&type=script&lang=js"
import style0 from "./HomeRecommended.vue?vue&type=style&index=0&id=056e8e30&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports